export default __webpack_public_path__ + "static/media/Paper1.e0aba631.svg";